import React from "react";
import styled from "styled-components";
import RaceButton from "../shared/RaceButton";
import type { RaceClock } from "../../hooks/useRaceClock";

const SignupMessage = styled.div`
  font-size: 1rem;
  font-weight: 900;
  color: #323232;
  text-align: center;
  margin-top: 2rem;
`;

/**
 * "You clicked before unlock" screen. An early tap never enters the race, so
 * the racer can simply tap again once it's unlocked. This used to force a
 * full browser reload, which cost a few seconds on a slow phone and raced the
 * next tap on a fresh page with no latency correction (2026-11-03 timing audit).
 * Mirrors monolith lines 1294–1322.
 */
export const EnteredEarlyState: React.FC<{
  msEarly: number;
  scheduledTime?: string;
  clock: RaceClock;
  onTap: (tapStartedAt: number) => void;
  tapBusy?: boolean;
}> = ({ msEarly, clock, onTap, tapBusy }) => (
  <SignupMessage
    style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}
  >
    <div style={{ color: "#ff3b3b", fontWeight: 700, marginBottom: "8px" }}>
      You clicked {msEarly}ms before unlock.
    </div>
    <div style={{ marginBottom: "4px" }}>Early clicks don&apos;t count. Tap again to race.</div>
    <RaceButton clock={clock} canRace onTap={onTap} busy={tapBusy} armedLabel="tap again" />
  </SignupMessage>
);

export default EnteredEarlyState;
